import React, { PropsWithChildren } from 'react';
import { Box } from '@mui/material';
import TopBar from '../components/TopBar/TopBar';

const SimpleLayout: React.FC<PropsWithChildren> = ({ children }) => {
    return (
        <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            {/* TopBar only - no sidebar */}
            <TopBar onDrawerToggle={() => {}} />

            <Box
                component='main'
                sx={{
                    flex: 1,
                    backgroundColor: '#FEFBFF',
                    overflow: 'auto',
                }}
            >
                {children}
            </Box>
        </Box>
    );
};

export default SimpleLayout;
